import BaseStore from './BaseStore'

export class ReceiveNumberStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'receive_numbers'
  }
}

export default new ReceiveNumberStore()


// WEBPACK FOOTER //
// ./src/stores/ReceiveNumberStore.js